import client from "../client/client";

class CollabService {
  getStringContent({ infoId }, cancelToken) {
    return client.get(`/smartview/information/${infoId}`, { config: { cancelToken } });
  }
}

export default new CollabService();
